import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AppRoutes } from 'src/app/shared/routes/routes';
import { StorageService } from 'src/app/shared/storage/storage.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import Swal from 'sweetalert2';

@Injectable()
export class PermisionInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private authService = inject(AuthService);
  private storage = inject(StorageService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((e: HttpErrorResponse) => {
        // Only handle 403 (forbidden) and 423 (locked) - NOT 401 (unauthorized)
        // 401 will be handled by AuthRefreshInterceptor
        if (e.status === 403 || e.status === 423) {
          console.log(
            'PermissionInterceptor: Received error status:',
            e.status,
            'for URL:',
            request.url,
          );

          // Access forbidden (403) or resource locked (423) - show message and redirect to home
          const message =
            e.status === 403
              ? "You don't have permission to access this resource."
              : 'This resource is currently locked or unavailable.';

          const user = this.authService.user;

          let nextRoute = AppRoutes.dashboard.dashboardUnique;

          if (user?.user_type === 'parent') {
            nextRoute = `${AppRoutes.dashboard.dashboardUnique}/${AppRoutes.dashboard.parentView}`;
          }

          Swal.fire({
            title: 'Access Denied',
            text: message,
            icon: 'warning',
            confirmButtonText: 'Go to Dashboard',
          }).then(() => {
            this.router.navigate([nextRoute]);
          });
        }
        return throwError(() => e);
      }),
    );
  }
}